import { GenericResultModel } from './base';

export enum ReasonType {
  Other = 0,
  TaskReopen = 1,
  ScheduleChange = 2,
  // Add other types here as needed
}

export interface Reason {
  id: number | null;
  name: string;
  type: ReasonType;
  isDeleted: boolean;
}

export interface GetReasonsRequestModel {
  type: ReasonType;
}

export interface WriteReasonRequestModel  {
  reason: Reason;
}

export interface GetReasonsResultModel extends GenericResultModel {
  reasons: Reason[];
}
